import { Gray200 } from '@zep-us/zus/tokens';
import { XSmallCircleColorIcon } from '@/icons';
import { type ButtonProps, IconButton } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
export const DeleteButton = ({
  onClick,
  disabled,
  ...rest
}: Omit<ButtonProps, 'asChild'>) => {
  return <IconButton {...rest} tabIndex={-1} onClick={onClick} disabled={disabled} size="2xs" intent="neutral" variant={'transparent'} className={cn(disabled && 'opacity-[0.54]')} rounded={'full'} data-sentry-element="IconButton" data-sentry-component="DeleteButton" data-sentry-source-file="DeleteButton.tsx">
      <XSmallCircleColorIcon size="sm" fill={Gray200} data-sentry-element="XSmallCircleColorIcon" data-sentry-source-file="DeleteButton.tsx" />
    </IconButton>;
};